import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$4, a as isPercentage } from './p-B_h4kHh1.js';
import { d as defineCustomElement$6 } from './p-C78HRAnj.js';
import { d as defineCustomElement$5 } from './p-BV0MGjHW.js';
import { d as defineCustomElement$3 } from './p-D-NDT90B.js';
import { d as defineCustomElement$2 } from './p-xjpL7DAY.js';

const jwPlayerBaseCss = ".wui-jw-player-base{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-block;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;position:relative}.wui-jw-player-base *,.wui-jw-player-base :after,.wui-jw-player-base :before{box-sizing:inherit}.wui-jw-player-base img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.wui-jw-player-base__player-container{align-items:center;bottom:0;display:flex;height:100%;justify-content:center;left:0;position:absolute;right:0;top:0;width:100%;z-index:0}wui-jw-player-base-container,wui-jw-player-base-injector{display:flex;flex:1;height:100%;width:100%}";

function parseAspectRatio(aspectratio) {
    return aspectratio.split(':').map((s) => +s);
}
function calcAspectRatioPercentage(aspectratio) {
    const [width, height] = parseAspectRatio(aspectratio);
    return (1 / (width / height)) * 100;
}
function toPx(val) {
    if (typeof val === 'number') {
        return `${val}px`;
    }
    return val || '';
}
function getDimensions(playerOptions = {}) {
    const { width, height, aspectratio } = playerOptions;
    // Default values as defined by jwplayer
    const defaultWidth = '640px';
    const defaultHeight = '360px';
    let finalWidth;
    let finalHeight;
    if (aspectratio && isPercentage(width)) {
        finalWidth = width;
        // Ignore height
    }
    else {
        finalWidth = toPx(width) || defaultWidth;
        finalHeight = toPx(height) || defaultHeight;
    }
    return {
        width: finalWidth,
        height: finalHeight,
    };
}
function getAspectBoxStyle(playerOptions) {
    if (!playerOptions) {
        return;
    }
    const { aspectratio, width } = playerOptions;
    if (aspectratio && isPercentage(width)) {
        return { paddingTop: `${calcAspectRatioPercentage(aspectratio)}%` };
    }
}
const WuiJwPlayerBase$1 = /*@__PURE__*/ proxyCustomElement(class WuiJwPlayerBase extends H {
    constructor() {
        super();
        this.__registerHost();
        this.playerInstantiate = createEvent(this, "playerInstantiate", 7);
        this.playerSetup = createEvent(this, "playerSetup", 7);
        this.playerError = createEvent(this, "playerError", 7);
        this.playerReady = createEvent(this, "playerReady", 7);
        this.isContentOverlayHidden = () => {
            // If we can't render a player, don't hide the content overlay
            const canRenderPlayer = this.playerLicenseKey && this.playerVersion;
            if (!canRenderPlayer) {
                return false;
            }
            // One of these props means that we need to overlay something
            if (this.showOverlay || this.loading || this.error) {
                return false;
            }
            // Default to true
            return true;
        };
    }
    render() {
        return (h(Host, { key: 'fa83457b00ce3c046ae4952307e83debb5242397', "data-error": Boolean(this.error), style: getDimensions(this.playerOptions), class: "wui-jw-player-base" }, h("div", { key: '4784e3e4d2ab7ff8486e3a9d2025737c0cd6bc97', style: getAspectBoxStyle(this.playerOptions) }), h("div", { key: '88a2021c69902906b6a49ee0b41baf0ffa367eb2', class: "wui-jw-player-base__player-container" }, this.playerLicenseKey && this.playerVersion && (h("wui-jw-player-base-injector", { key: `${this.playerVersion}_${this.playerLicenseKey}`, playerLicenseKey: this.playerLicenseKey, playerVersion: this.playerVersion, playerOptions: this.playerOptions }))), h("wui-jw-player-base-overlay", { key: '28065e3b82c846916415a8fd8fc80b72e32eb13a', visible: !this.isContentOverlayHidden(), loading: !!this.loading, loadingText: this.loading && typeof this.loading === 'string' ? this.loading : undefined, error: this.error, errorLink: this.errorLink }, h("slot", { key: '95ffb488d1989c680ea63950ba4787bc45130a0f' }))));
    }
    static get style() { return jwPlayerBaseCss; }
}, [260, "wui-jw-player-base", {
        "playerOptions": [16, "player-options"],
        "playerVersion": [1, "player-version"],
        "playerLicenseKey": [1, "player-license-key"],
        "showOverlay": [4, "show-overlay"],
        "loading": [520],
        "error": [16],
        "errorLink": [1, "error-link"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-jw-player-base", "wui-icon", "wui-jw-player-base-injector", "wui-jw-player-base-injector-container", "wui-jw-player-base-overlay", "wui-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-jw-player-base":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiJwPlayerBase$1);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-jw-player-base-injector":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-jw-player-base-injector-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-jw-player-base-overlay":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiJwPlayerBase = WuiJwPlayerBase$1;
const defineCustomElement = defineCustomElement$1;

export { WuiJwPlayerBase, defineCustomElement };
